import React from "react";
import { List, ListItemButton, ListItemText, Typography } from "@mui/material";

function SubfolderList({ subfolders, selectedSubfolder, onSubfolderSelect }) {
  console.log("[ADMIN][DEBUG][TITLE]: SubfolderList.js");
  console.log("[ADMIN][DEBUG]: subfolders: ", subfolders);
  console.log("[ADMIN][DEBUG]: selectedSubfolder: ", selectedSubfolder);
  if (!subfolders || subfolders.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No subfolders available.
      </Typography>
    );
  }

  return (
    <List sx={{ maxHeight: "60vh", overflowY: "auto" }}>
      {subfolders.map((subfolder) => (
        <ListItemButton
          key={subfolder.id}
          selected={selectedSubfolder && selectedSubfolder.id === subfolder.id}
          onClick={() => onSubfolderSelect(subfolder)}
        >
          <ListItemText primary={subfolder.subfolderName} />
        </ListItemButton>
      ))}
    </List>
  );
}

export default SubfolderList;
